module.exports = __webpack_public_path__ + "img/logo.49fc9f3b.png";